const config = {
  apiUrl: process.env.NODE_ENV === 'production' ? 'https://v3e3wpd2otxlaahaicwscjjy6u0tevsm.lambda-url.us-east-1.on.aws/' : 'https://localhost:7146',
  apiChatUrl: process.env.NODE_ENV === 'production' ? 'https://ivy7pfevq7impw75fmgt76i6hu0qicek.lambda-url.us-east-1.on.aws/' : 'https://localhost:7146'
};

export default config; 